import type { ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
}

/**
 * Standard page chrome for views rendered through the Router. Provides the
 * canonical 100% × 100% surface with 10px gutters as a flex column so view
 * content can use `flex: 1` to fill or scroll independently.
 *
 * Views that need to bleed to the edges (full-screen viewers, immersive
 * dashboards) can opt out by declaring `layout: 'full-bleed'` on their entry
 * in `view-registry.ts` — the Router will skip this wrapper for them.
 */
export function PageShell({ children }: PageShellProps) {
  return <div className="page-shell">{children}</div>;
}
